<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Comprobantes de Pago"
          directory="Verificación de comprobantes de pago"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
        </div>
      </div>
    </div>

    <div class="col-12" v-if="evaluationList && evaluationList.length > 0">
      <app-note
        class="pt-2 clearfix"
        :title="$t('Procesos en bloque')"
        content-type="html"
        note-type="note-warning"
        :notes="[
          $t(
            'Se efectuará la misma acción para las siguientes evaluaciones o testificaciones'
          ),
        ]"
      />
    </div>
    <br />
    <div class="col-12" v-if="evaluationList && evaluationList.length > 0">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th scope="col">Expediente</th>
            <th scope="col">Tipo</th>
            <th scope="col">Código</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(value, key) in evaluationList" :key="key">
            <td class="align-middle">
              {{ value.accreditation_applications.record }}
            </td>
            <td class="align-middle">
              <br />
              <p v-if="value.type == 'E'">Evaluación</p>
              <p v-if="value.type == 'T'">Testificación</p>
            </td>
            <td class="align-middle">{{ value.code }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <form
      ref="form"
      :data-url="`/treasury/deposits/${depositId}`"
      :class="{ 'loading-opacity': preloader }"
      enctype="multipart/form-data"
    >
      <div v-if="inputs.i_business_name">
        <div class="row" v-if="!inputs.is_agreement">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>DATOS PARA FACTURACIÓN</h5>
          </legend>

          <div class="col-md-6">
            <div class="form-group">
              <label>Razón Social</label>
              <app-input
                type="text"
                v-model="inputs.i_business_name"
                :disabled="disabled"
                placeholder="Ingrese el Razón social"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>RUC</label>
              <app-input
                type="text"
                v-model="inputs.i_taxid"
                :disabled="disabled"
                placeholder="Ingrese el RUC"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>País</label>
              <app-input
                type="select"
                v-model="inputs.i_country_id"
                :list="countryList"
                :disabled="disabled"
              />
            </div>
          </div>

          <div
            class="col-md-6"
            v-if="inputs.i_country_id && !inputs.i_province_id"
          >
            <div class="form-group">
              <label>Ciudad</label>
              <app-input
                type="text"
                v-model="inputs.i_city"
                placeholder="Ingrese la ciudad"
                :disabled="disabled"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="inputs.i_province_id">
            <div class="form-group">
              <label>Provincia</label>
              <app-input
                type="select"
                v-model="inputs.i_province_id"
                :list="provinceList"
                :disabled="disabled"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="inputs.i_province_id">
            <div class="form-group">
              <label>Ciudad</label>
              <app-input
                type="select"
                v-model="inputs.i_canton_id"
                :list="cantonList"
                :disabled="disabled"
                placeholder="Ingrese la ciudad"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>E-mail</label>
              <app-input
                type="email"
                v-model="inputs.i_email"
                placeholder="Ingrese su email"
                :disabled="disabled"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Teléfono</label>
              <app-input
                type="tel-input"
                v-model="inputs.i_phone"
                :disabled="disabled"
                placeholder="Ingrese el teléfono"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Dirección</label>
              <app-input
                type="textarea"
                v-model="inputs.i_address"
                :disabled="disabled"
                placeholder="Ingrese la dirección"
              />
            </div>
          </div>
        </div>
      </div>

      <div v-if="inputs.delegate_name">
        <div class="row">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>DATOS PERSONA RESPONSABLE DE LA ACREDITACIÓN (CONTACTO)</h5>
          </legend>

          <div class="col-md-6">
            <div class="form-group">
              <label>Nombre</label>
              <app-input
                type="text"
                v-model="inputs.delegate_name"
                :disabled="disabled"
                placeholder="Ingrese el nombre"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Cargo</label>
              <app-input
                type="text"
                v-model="inputs.delegate_position"
                :disabled="disabled"
                placeholder="Ingrese el RUC"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>E-mail</label>
              <app-input
                type="email"
                v-model="inputs.delegate_email"
                placeholder="Ingrese su email"
                :disabled="disabled"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Teléfono</label>
              <app-input
                type="tel-input"
                v-model="inputs.delegate_phone"
                :disabled="disabled"
                placeholder="Ingrese el teléfono"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Celular</label>
              <app-input
                type="tel-input"
                v-model="inputs.delegate_cell"
                :disabled="disabled"
                placeholder="Ingrese el teléfono"
              />
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="row">
          <legend
            class="col-12 col-form-label text-primary pt-0 my-3"
            v-if="!inputs.is_agreement"
          >
            <h5>{{ titlePayment }}</h5>
          </legend>

          <div class="col-md-6" v-if="!inputs.is_agreement">
            <div class="form-group">
              <label>Beneficiario</label>
              <app-input
                id="inputs_beneficiary"
                type="text"
                disabled
                v-model="inputs.beneficiary"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="!inputs.is_agreement">
            <div class="form-group">
              <label>OEC</label>
              <app-input
                id="inputs_oec"
                type="text"
                disabled
                v-model="inputs.oec"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="!inputs.is_agreement">
            <div class="form-group">
              <label>Banco</label>
              <app-input
                id="inputs_bank"
                type="text"
                disabled
                v-model="inputs.bank"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="!inputs.is_agreement">
            <div class="form-group">
              <label>Tipo de Transacción</label>
              <app-input
                id="inputs_trasaction"
                type="text"
                disabled
                v-model="inputs.transactiontype"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="!inputs.is_agreement">
            <div class="form-group">
              <label>Número de Transacción</label>
              <app-input
                id="inputs_number"
                type="text"
                :disabled="hide"
                v-model="inputs.number"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="!inputs.is_agreement">
            <div class="form-group">
              <label>Valor</label>
              <app-input
                id="inputs_amount"
                type="text"
                disabled
                v-model="inputs.amount"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="!inputs.is_agreement">
            <div class="form-group">
              <label>Fecha</label>
              <app-input
                id="inputs_date"
                type="date"
                :disabled="hide"
                v-model="inputs.date"
                :required="true"
              />
            </div>
          </div>

          <div class="col-12">
            <br />
          </div>

          <div class="col-12" v-if="!inputs.is_agreement">
            <legend>
              <p class="text-primary">Documentos</p>
            </legend>
          </div>

          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th>FECHA DE CREACIÓN</th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="inputs.request_file">
                  <td class="align-middle">
                    <strong>Solicitud de Acreditación</strong>
                  </td>
                  <td class="align-middle">
                    {{ inputs.request_file.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <a
                      :href="inputs.request_file.full_url"
                      class="btn btn-success btn-md"
                      target="_blank"
                    >
                      <app-icon name="file"></app-icon> Ver
                    </a>
                  </td>
                </tr>

                <tr v-if="inputs.deposit_attach">
                  <td class="align-middle">
                    <p class="card-title m-0" v-if="!inputs.is_agreement">
                      <strong>Comprobante de Pago</strong>
                    </p>
                    <p class="card-title m-0" v-if="inputs.is_agreement">
                      <strong>Convenio</strong>
                    </p>
                  </td>
                  <td class="align-middle">
                    {{ inputs.deposit_attach.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <a
                      :href="inputs.deposit_attach.full_url"
                      class="btn btn-success btn-md"
                      target="_blank"
                    >
                      <app-icon name="file"></app-icon> Ver
                    </a>
                  </td>
                </tr>

                <tr v-if="inputs.proforma">
                  <td class="align-middle">
                    <strong>Proforma</strong>
                  </td>
                  <td class="align-middle">
                    {{ inputs.proforma.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <a
                      :href="inputs.proforma.full_url"
                      class="btn btn-success btn-md"
                      target="_blank"
                    >
                      <app-icon name="file"></app-icon> Ver
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />

          <div class="col-12" v-if="(eval_annexes_files) || (eval_team && Array.isArray(eval_team) && eval_team.some(item => item.eval_test.evaluation_team_external))">
            <!-- <legend v-if="!inputs.is_agreement">
              <p class="text-primary">
                Pagos de honorarios de personal externo
              </p>
            </legend> -->
            <table
              class="table table-sm table-striped"
              v-if="!inputs.is_agreement"
            >
              <!-- <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th>FECHA DE CREACIÓN</th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead> -->
              <tbody>
                <tr
                  v-if="eval_annexes_files.length > 0"
                  style="text-align: center"
                >
                  <td colspan="3" class="text-primary" style="text-align: left">
                    <br /><br />
                    <b>Anexos de honorarios del personal externo</b>
                  </td>
                </tr>
                <tr v-if="eval_annexes_files.length > 0">
                  <th scope="col">NOMBRE</th>
                  <th>FECHA DE CREACIÓN</th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
                <tr v-for="(item, c) in eval_annexes_files" :key="c + 1">
                  <td class="align-middle">{{ item.filename }}</td>
                  <td class="align-middle">
                    {{ item.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <a
                      :href="item.annexed.full_url"
                      class="btn btn-success btn-md"
                      target="_blank"
                    >
                      <app-icon name="file"></app-icon> Ver
                    </a>
                  </td>
                </tr>
                <tr v-for="ext in eval_team" :key="ext.id">
                <td class="align-middle" v-if="ext.evaluation_team_external">
                  {{
                      ext.evaluator
                        ? `${ext.evaluator.first_name} ${ext.evaluator.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle" v-if="ext.evaluation_team_external">
                  {{ ext.evaluation_team_external.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center" v-if="ext.evaluation_team_external">
                  <button type="submit" class="btn btn-success" @click.prevent="openTabExt(ext,'evaluation_team_external')">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
                <!-- <tr
                  v-if="inputs.eval_test.external_personal_payment_vouchers"
                  style="text-align: center"
                >
                  <td colspan="3" class="text-primary" style="text-align: left">
                    <br><br>
                    <b>Comprobantes de pagos personal externo</b>
                  </td>
                </tr>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th>FECHA DE CREACIÓN</th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
                <tr
                  v-for="(i, j) in inputs.eval_test
                    .external_personal_payment_vouchers"
                  :key="j + 40"
                >
                  <td class="align-middle">{{ i.filename }}</td>
                  <td class="align-middle">
                    {{ i.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <a
                      :href="i.annexed.full_url"
                      class="btn btn-success btn-md"
                      target="_blank"
                    >
                      <app-icon name="file"></app-icon> Ver
                    </a>
                  </td>
                </tr>
                <tr
                  v-if="inputs.eval_test.external_personal_payment_invoices"
                  style="text-align: left" class="text-primary"
                >
                  <td colspan="3">
                    <br><br>
                    <b>Facturas de pagos personal externo</b></td>
                </tr>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th>FECHA DE CREACIÓN</th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
                <tr
                  v-for="(l, k) in inputs.eval_test
                    .external_personal_payment_invoices"
                  :key="k + 80"
                >
                  <td class="align-middle">{{ l.filename }}</td>
                  <td class="align-middle">
                    {{ l.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <a
                      :href="l.annexed.full_url"
                      class="btn btn-success btn-md"
                      target="_blank"
                    >
                      <app-icon name="file"></app-icon> Ver
                    </a>
                  </td>
                </tr> -->
              </tbody>
            </table>
          </div>
          <!-- Fin archivos por honorarios -->
          <div class="col-12">
            <br />
          </div>

          <div class="col-md-12">
            <div class="form-group text-center">
              <app-input
                type="radio-buttons"
                v-model="inputs.is_approved"
                :list="confirm"
                :disabled="hide"
              />
            </div>
          </div>

          <div class="col-md-12" v-if="!hide">
            <br />
            <app-badge
              v-if="!inputs.is_approved"
              label="RECHAZADA"
              className="badge badge-danger badge-lg"
              class="col-sm-12"
            />
            <app-badge
              v-if="inputs.is_approved"
              label="APROBADA"
              className="badge badge-success badge-lg"
              class="col-sm-12"
            />
          </div>

          <div class="col-md-12" v-if="!inputs.is_approved">
            <div class="form-group">
              <br />
              <label>Justificación del rechazo del comprobante de pago</label>
              <app-input
                id="inputs_observations"
                type="textarea"
                style="border-color: 1px solid #366ab9 !important"
                v-model="inputs.observations"
                :disabled="hide"
                :required="true"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="!hide">
        <div class="col-12 mt-3">
          <button
            type="submit"
            class="btn btn-primary mr-2"
            @click.prevent="submit"
          >
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import * as actions from "../../apiUrl";
import { FormMixin } from "@/core/mixins/form/FormMixin.js";

export default {
  mixins: [FormMixin],
  props: {
    depositId: String,
  },
  data() {
    return {
      preloader: true,
      hide: false,
      disabled: true,
      showAdditional: false,
      titlePayment: "DATOS PARA EL PAGO DE ",
      inputs: {},
      confirm: [
        {
          id: 0,
          value: "RECHAZADO",
        },
        {
          id: 1,
          value: "APROBADO",
        },
      ],
      deleteModal: false,
      eval_annexes_files: "",
      eval_external_files: "",
      eval_team: "",
      countryLists: [],
      selectedUrl: "",
      countryList: [{ id: "", value: "Seleccione País" }],
      provinceLists: [],
      provinceList: [{ id: "", value: "Seleccione Provincia" }],
      cantonLists: [],
      evaluationList: "",
      cantonList: [{ id: "", value: "Seleccione Canton" }],
    };
  },
  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },
  created() {
    this.selectedUrl = `${actions.TREASURY}/${this.depositId}`;
    this.loadForm();
    this.getInfo();
  },
  methods: {
    returnPage() {
      window.location.href = `${actions.TREASURY}`;
    },
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      const tmp = { ...this.inputs };
      if (tmp.is_approved) {
        tmp.is_approved = 2;
      } else {
        tmp.is_approved = 0;
      }
      const d = tmp.date;
      if (tmp.date) {
        tmp.date = [d.getFullYear(), d.getMonth() + 1, d.getDate()].join("-");
      }
      this.save(tmp);
    },
    afterSuccess(res) {
      this.preloader = true;
      if (res.status == 200) {
        this.returnPage();
      }
    },
    afterFinalResponse() {
      this.preloader = false;
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    loadForm() {
      if (this.depositId) {
        let url = `${actions.TREASURY}/${this.depositId}`;
        this.axiosGet(url)
          .then((response) => {
            if (response.status == 200) {
              if (response.data.is_approved === 3) {
                this.hide = true;
              }
              this.inputs = response.data;
              this.inputs.is_agreement = response.data.is_agreement;
              if (response.data.eval_test) {
                this.eval_annexes_files =
                  response.data.eval_test.eval_annexes_files;
              }
              if (response.data.eval_test) {
                this.eval_team =
                  response.data.eval_test.evaluation_team;
                  
              }
              if (this.inputs.type === "S") {
                this.titlePayment =
                  this.titlePayment + "SOLICITUD DE ACREDITACION";
              } else {
                this.titlePayment = this.titlePayment + "PROFORMA DE SERVICIOS";
              }
              this.inputs.bank = response.data.bank
                ? response.data.bank.name +
                  " - " +
                  response.data.bank.account_number
                : "N/A";
              this.inputs.amount = response.data.amount
                ? response.data.amount + " USD"
                : "N/A";
              this.inputs.transactiontype = response.data.transactiontype
                ? response.data.transactiontype.name
                : "N/A";
              this.inputs.oec =
                response.data.accreditation_application.organization.name;
              this.inputs.taxid =
                response.data.accreditation_application.organization.taxid;
              this.inputs.delegate_name =
                response.data.accreditation_application.delegate_name;
              this.inputs.delegate_position =
                response.data.accreditation_application.delegate_position;
              this.inputs.delegate_email =
                response.data.accreditation_application.delegate_email;
              this.inputs.delegate_phone =
                response.data.accreditation_application.delegate_phone;
              this.inputs.delegate_cell =
                response.data.accreditation_application.delegate_cell;
              this.inputs.is_approved = false;
              var dateString = response.data.date;
              var startDate = new Date(dateString);
              var day = 60 * 60 * 24 * 1000;
              this.inputs.date = new Date(startDate.getTime() + day);
              if (response.data.file) {
                this.inputs.deposit_attach = response.data.file;
              } else {
                this.inputs.deposit_attach = "";
              }

              if (response.data.evaluationList && response.data.evaluationList.length > 0) {
                this.evaluationList = response.data.evaluationList;
              }

              if (response.data.complementary_documents_deposits) {
                this.inputs.additional_attach =
                  this.inputs.complementary_documents_deposits.full_url;
                this.showAdditional = true;
              } else {
                this.inputs.additional_attach = "";
              }

              if (response.data.accreditation_application.request_signed) {
                this.inputs.request_file =
                  response.data.accreditation_application.request_signed;
              } else {
                this.inputs.request_file = null;
              }

              if (response.data.eval_test.proforma) {
                this.inputs.proforma = response.data.eval_test.proforma;
              } else {
                this.inputs.proforma = null;
              }

              if (response.data.eval_test.external_personal_payment_invoices) {
                this.inputs.external_personal_payment_invoices =
                  response.data.eval_test.external_personal_payment_invoices.full_url;
              } else {
                this.inputs.external_personal_payment_invoices = null;
              }

              if (response.data.eval_test.external_personal_payment_vouchers) {
                this.inputs.external_personal_payment_vouchers =
                  response.data.eval_test.external_personal_payment_vouchers.full_url;
              } else {
                this.inputs.external_personal_payment_vouchers = null;
              }
              // this.getInfo();
            }
          })
          .catch(({ error }) => {})
          .finally(() => {
            this.preloader = false;
          });
      }
    },
    getInfo() {
      let url = `${actions.COMMON_POLITICAL_DIVISION}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            this.countryLists = response.data.countries;
            this.countryList = [
              ...this.countryLists.filter((item) => {
                return item;
              }),
            ];

            this.provinceLists = response.data.provinces;
            this.provinceList = [
              ...this.provinceLists.filter((item) => {
                return item;
              }),
            ];
            this.cantonLists = response.data.cantons;
            this.cantonList = [
              ...this.cantonLists.filter((item) => {
                return item;
              }),
            ];
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    openTabExt(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },
  },
};
</script>